import firebase from 'firebase/compat/app';
import { getDatabase } from "firebase/database";
import { getRemoteConfig } from 'firebase/remote-config';
import { fetchAndActivate, getAll } from 'firebase/remote-config';

import 'firebase/compat/auth';
import 'firebase/compat/firestore';

import { getMessaging, getToken, onMessage } from 'firebase/messaging';

let cachedRemoteConfigObject = null;

let firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASEURL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
    appId: process.env.REACT_APP_FIREBASE_APPID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID
};

const Firebase = firebase.initializeApp(firebaseConfig);
const messaging = getMessaging();

// Initialize Remote Config
const firebaseRemoteConfig = getRemoteConfig(Firebase);

// Set default settings for Remote Config (optional)
firebaseRemoteConfig.settings = {
    fetchTimeoutMillis: 60000, // Increase timeout to 60 seconds
    minimumFetchIntervalMillis: 60000, // Set minimum fetch interval to 1 minutes cache
};

export const requestForToken = () => {
    return getToken(
        messaging,
        { vapidKey: `BHBlbxmz3eQ5_85beZICOM4vGbwmCkMoDbTHD0JJktazxWFhr7Pjp47qIRMHJO1axnbR9w7nKm8AxZ9054mrrKg` }
    ).then((currentToken) => {
        if (currentToken) {
            return currentToken;
        } else {
            // Show permission request UI
            console.log('No registration token available. Request permission to generate one.');
        }
    }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
    });
};

export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });

export const fetchRemoteConfigData = async (configDataType = null) => {
    try {
        // Return cached data if available
        if (cachedRemoteConfigObject) {
            return configDataType
                ? cachedRemoteConfigObject[configDataType] || null
                : cachedRemoteConfigObject;
        }

        // Fetch and activate the latest values
        await fetchAndActivate(remoteConfig);

        // Get all Remote Config parameters
        const allValues = getAll(remoteConfig);

        // Parse and store them in cache
        cachedRemoteConfigObject = {};
        Object.keys(allValues).forEach((key) => {
            const value = allValues[key].asString();
            try {
                cachedRemoteConfigObject[key] = JSON.parse(value);
            } catch {
                cachedRemoteConfigObject[key] = value; // fallback for non-JSON strings
            }
        });

        // Return a specific config type or everything
        return configDataType
            ? cachedRemoteConfigObject[configDataType] || null
            : cachedRemoteConfigObject;
    } catch (error) {
        console.error("Error fetching remote config:", error);
        return null;
    }
};

export const firestore = Firebase.firestore();
export const disputesRef = Firebase.firestore().collection('disputes');
export const chatsRef = Firebase.firestore().collection('chats');
export const messagesRef = Firebase.firestore().collection('messages');
export const usersRef = Firebase.firestore().collection('users');
export const jobsRef = Firebase.firestore().collection('jobs');
export const realtime = getDatabase(Firebase);
export const remoteConfig = firebaseRemoteConfig;